import apiAuth from "./apiAuth";
import authHeader from "./auth-header";
import axios from "axios";

const API_URL =
  process.env.NODE_ENV === "production"
    ? "https://robsdyno.malejkoit.com/api/v1.0.0/"
    : "http://localhost:8000/api/v1.0.0/";

class ServiceApiService {
  getServices(firstDay, lastDay, status = null) {
    let url = API_URL + `services/?from=${firstDay}&to=${lastDay}`;
    if (status) url += `&status=${status}`;
    return apiAuth.get(url, { headers: authHeader() });
  }

  getServicesByClient(client) {
    return apiAuth.get(
      API_URL + `services/?search=client&client=${client}&limit=100`,
      { headers: authHeader() }
    );
  }

  createService(data) {
    return apiAuth.post(API_URL + "services/", data, { headers: authHeader() });
  }

  updateService(id, data) {
    return apiAuth.patch(API_URL + `services/${id}/`, data, { headers: authHeader() });
  }

  cancelService(id, data) {
    return apiAuth.patch(API_URL + `services/${id}/cancel/`, data, { headers: authHeader() });
  }

  completeService(id) {
    return apiAuth.patch(API_URL + `services/${id}/complete/`, {}, { headers: authHeader() });
  }

  missedService(id) {
    return apiAuth.patch(API_URL + `services/${id}/missed/`, {}, { headers: authHeader() });
  }

  depositService(id) {
    return apiAuth.patch(API_URL + `services/${id}/deposit/`, {}, { headers: authHeader() });
  }

  // Public endpoints (no auth needed)
  getServiceConfirmation(id) {
    return axios.get(API_URL + `service-confirm/${id}/`);
  }

  confirmServicePayment(id, data) {
    return axios.post(API_URL + `service-confirm/${id}/`, data);
  }

  getServiceCancel(id) {
    return axios.get(API_URL + `service-cancel/${id}/`);
  }

  cancelServiceByClient(id) {
    return axios.post(API_URL + `service-cancel/${id}/`, {});
  }
}

export default new ServiceApiService();
